import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Column, Flex } from '../layout';
import { styled } from '../../styles';
import { TranscriptItem } from './transcript_item';
import { Button } from '../buttons';
import { AppIcon } from '../icons';
import { AppText } from '../typography';
import { RoundedSearch } from '../inputs';
import { RESUME_AUTO_SCROLL_BUTTON } from '../notes/consts';
import { useTranscriptContainer } from '../../hooks/transcripts/use_transcript_container';
export const TranscriptContainer = ({ transcriptBlocks, selectedItemIndex, autoScrollModeActive, analyticsHandlers, handleTimeStampJump, searchPlaceholder = 'Search Transcript', onSearch, searchValue, clearSearch, updateAutoScrollMode, roomSid, }) => {
    const { recordScrollEvent, recordClickEvent } = analyticsHandlers;
    const { filteredBlocks, selectedBlock, scrollRef, matchingSearchTerms } = useTranscriptContainer({
        transcriptBlocks,
        selectedItemIndex,
        searchValue,
        recordScrollEvent,
        updateAutoScrollMode,
        roomSid,
    });
    return (_jsxs(TranscriptWrapper, { "data-testid": "transcription-wrapper", children: [onSearch && (_jsx(SearchBarWrapper, { "data-testid": "transcript-search-wrapper", children: _jsx(RoundedSearch, { "data-testid": "transcript-search", name: searchPlaceholder, label: searchPlaceholder, placeholder: searchPlaceholder, onChange: onSearch, value: searchValue, clearSearch: clearSearch, autoFocus: false }) })), _jsxs(TranscriptScrollWrapper, { ref: scrollRef, "data-testid": "transcription-scroll-wrapper", children: [filteredBlocks.length > 0
                        ? filteredBlocks.map((block, idx) => {
                            const isSelected = selectedBlock !== null &&
                                block.startTimeMs === selectedBlock.startTimeMs &&
                                block.speakerName === selectedBlock.speakerName;
                            return (_jsx(TranscriptItem, { transcriptBlock: block, index: idx, isSelected: isSelected, autoScrollModeActive: autoScrollModeActive, handleTimeStampJump: handleTimeStampJump, searchValue: searchValue, matchingSearchTerms: matchingSearchTerms, recordClickEvent: recordClickEvent }, `${block.startTimeMs}-${block.speakerName}`));
                        })
                        : transcriptBlocks.length > 0 && (_jsxs(NoResultsMessage, { children: ["No results found for ", searchValue] })), !autoScrollModeActive && (_jsx(AutoScrollButton, { analyticsClickHandler: recordClickEvent, updateAutoScrollMode: updateAutoScrollMode }))] })] }));
};
const TranscriptWrapper = styled(Column)(({ theme }) => ({
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '1rem 1.5rem 0 1.5rem',
    height: '45.25rem',
    gap: '1rem',
    border: `0.063rem solid ${theme.colors.grey10}`,
    borderRadius: '0.5rem',
    maxWidth: '34.625rem',
}));
const AutoScrollButton = ({ analyticsClickHandler, updateAutoScrollMode, }) => {
    const handleResumeScroll = () => {
        updateAutoScrollMode(true);
        analyticsClickHandler(RESUME_AUTO_SCROLL_BUTTON);
    };
    return (_jsx(AutoScrollButtonWrapper, { "data-testid": "transcript-auto-scroll-button", children: _jsxs(StyledAutoScrollButton, { onClick: handleResumeScroll, children: [_jsx(UpArrow, {}), _jsx(AppText, { as: 'p', headingFontFamily: true, color: "white", children: "Resume Autoscroll" })] }) }));
};
const UpArrow = () => {
    return (_jsx(IconContainer, { children: _jsx(AppIcon, { name: "BackIcon", size: "medium", color: "white" }) }));
};
const StyledAutoScrollButton = styled(Button)(() => ({
    span: {
        gap: '.5rem',
    },
}));
const AutoScrollButtonWrapper = styled(Flex)(({ theme }) => ({
    justifyContent: 'center',
    position: 'sticky',
    bottom: '0',
    background: theme.colors.white,
    padding: '0.625rem 0',
}));
const TranscriptScrollWrapper = styled(Column)(() => ({
    overflowY: 'auto',
    overflowX: 'hidden',
    gap: '1.5rem',
    flex: 1,
    padding: '0rem 1rem 0 0',
}));
const IconContainer = styled('div')({
    transform: 'rotate(90deg)',
});
const SearchBarWrapper = styled(Flex)(() => ({
    '& > *': {
        width: '100%',
        height: '100%',
    },
}));
const NoResultsMessage = styled(AppText)(({ theme }) => ({
    textAlign: 'center',
    color: theme.colors.grey40,
}));
//# sourceMappingURL=transcript_container.js.map